/**
 *
 * @type {
 * (
 * {GOLD: string, BRONZE: string, SILVER: string, PLATINUM: string} | {})
 * &{NON_LOYALIST: string
 * }
 * }
 */
export const TIER_NAMES = {
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
  PLATINUM: 'platinum',
};

export const MIN_SPEND_TO_UPGRADE = {
  [TIER_NAMES.SILVER]: 400,
  [TIER_NAMES.GOLD]: 1000,
};

export const MAX_SPEND_TO_UPGRADE = {
  [TIER_NAMES.SILVER]: 500,
  [TIER_NAMES.GOLD]: 1200,
};

export const POINTS_PER_DOLLAR_BY_TIER = {
  'non-loyalist': 0,
  [TIER_NAMES.BRONZE]: 1,
  [TIER_NAMES.SILVER]: 2,
  [TIER_NAMES.GOLD]: 3,
  [TIER_NAMES.PLATINUM]: 5,
};
